// extracted by mini-css-extract-plugin
export var avatarContainer = "_7o-0";
export var avatarTypingWave = "_7o-i";
export var gray = "_7o-f";
export var green = "_7o-c";
export var icon = "_7o-9";
export var image = "_7o-1";
export var lg = "_7o-6";
export var md = "_7o-5";
export var presenceDot = "_7o-b";
export var red = "_7o-d";
export var sm = "_7o-4";
export var status = "_7o-a";
export var typingDot = "_7o-h";
export var typingPill = "_7o-g";
export var xl = "_7o-7";
export var xs = "_7o-3";
export var xxl = "_7o-8";
export var xxs = "_7o-2";
export var yellow = "_7o-e";